import { getConfig } from "./config/five9ChatConfig";
import { startCheckingState } from "./five9ChatSurvey";
import { render } from "react-dom";
import { ChatButton } from "./ChatButton";
import { Five9AllConfig } from "./config/five9-typings";

declare const FIVE9_ENV: string;
declare const Five9SocialWidget: any;
declare const isMobile: any;
const Five9WidgetURL = "https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js";

export let waitingForScriptToload = false;

export type InitializeChatParams = {
  locale: string;
  country?: string;
};

export type InitializeChatResponse = {
  isLocaleSupported: boolean;
  isChatLoaded: boolean;
};

function loadChat(config: Five9AllConfig): boolean {
  try {
    addChatStyle();
    addChatScript(config);
    return true;
  } catch (e) {
    logException(`Error: Five9 Widget not loaded! due exception: ${e}`);
    return false;
  }
}

function addChatStyle() {
  const style = document.createElement("style");
  style.innerText = "@media screen and (max-width: 767px) { .five9-header { text-align: right; } div.five9-frame { z-index: 1000; } }";
  document.head.appendChild(style);
}

function addChatScript(config: Five9AllConfig) {
  const existingScript = document.querySelector<HTMLScriptElement>(`script[src^="${Five9WidgetURL}"]`);
  if (existingScript) {
    if (waitingForScriptToload) {
      setTimeout(() => {
        addWidget(config);
      }, 1000);
    } else {
      addWidget(config);
    }
  } else {
    waitingForScriptToload = true;
    const script = document.createElement("script");
    script.setAttribute("src", Five9WidgetURL);
    script.onload = () => {
      waitingForScriptToload = false;
      addWidget(config);
    };
    document.body.appendChild(script);
  }
}

function addWidget(config: Five9AllConfig) {
  logMessage(`Adding widget for config ${JSON.stringify(config)}`);
  if (typeof isMobile !== "undefined") {
    isMobile.any = false;
  }
  if (Five9SocialWidget) {
    Five9SocialWidget.removeWidget();
    Five9SocialWidget.addWidget(config);
  } else {
    logException("Five9 Chat was not added!");
  }
  
  if (config.defaultProfile != undefined) {
    const realButton = document.getElementById("five9-maximize-button")!;
    realButton.style.display = "none";
    const fakeButton = document.createElement("div");
    render(<ChatButton config={config} onLanguageSelected={onLanguageSelected} />, fakeButton)
    realButton.parentNode!.parentNode!.appendChild(fakeButton);
  }
}

function onLanguageSelected(profile: string, config: Five9AllConfig, isAutoSelect: boolean): void {
  Five9SocialWidget.removeWidget();
  const widgetConfig = profile ? getConfig(profile) : config;
  isMobile.any = false;
  Five9SocialWidget.addWidget(widgetConfig);
  startCheckingState(config!.vivrURL!) // config will be always not null
  if(!isAutoSelect){
    const realButton = document.getElementById('five9-maximize-button')!
    realButton.click();
  }
}

export function initializeChat({ locale, country }: InitializeChatParams) {
  return new Promise<InitializeChatResponse>((resolve, reject) => {
    const result = { isLocaleSupported: false, isChatLoaded: false };
    try {
      let nfrCountryCode: string | undefined;
      if (locale == "en-US" && country && country != "USA") {
        nfrCountryCode = country;
      }

      logMessage(`InitializeChat for locale: ${locale}, NFR Country:${nfrCountryCode}`);
      const config = getConfig(locale, nfrCountryCode);
      if (config) {
        if (country && country == "USA") {
          config.showProfiles = false;
        }
        result.isLocaleSupported = true;
        result.isChatLoaded = loadChat(config);
        if (result.isChatLoaded) {
          startCheckingState(config.vivrURL!);
          hideBoldChatIfExists();
        }
      } else {
        logMessage(`Five9 Chat does not support locale: ${locale}`);
      }
      resolve(result);
    } catch (e) {
      logException("Five9 Chat was not initialized!");
      reject({ isChatLoaded: result });
    }
  });
}

function logMessage(message: string): void {
  const now = new Date();
  const timestamp = `${now.toLocaleTimeString("en-US", { hour12: false })}.${now.getMilliseconds().toString().padStart(3, "0")}`;
  if (typeof FIVE9_ENV !== "undefined" && FIVE9_ENV !== "prod") {
    console.log(`[five9-chat-nonprod:${timestamp}]`, message);
  }
}

function logException(message: string): void {
  console.error("[five9-chat-exception]", message);
}

function hideBoldChatIfExists(): void {
  const mainSiteBoldChat = document.querySelectorAll('a[href*="livechat.boldchat.com"]');
  if (mainSiteBoldChat) {
    mainSiteBoldChat.forEach((a) => a.remove());
  }
}

export function removeFive9Widget() {
  Five9SocialWidget.removeWidget();
}
